<mat-toolbar class="nav-bar">
  <mat-toolbar-row>

    <!-- Hamburger (mobile only) -->
    <button mat-icon-button aria-label="Open navigation" class="nav-hamburger only-mobile"
      [matMenuTriggerFor]="mobileMenu" #hamburgerTrigger="matMenuTrigger">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Logo + Brand -->
    <div class="nav-item mt-2 mr-4">
      <span class="d-flex align-items-center">
        <img class="nav-logo" src="https://hsccdn.blob.core.windows.net/devcdn/unthealthlogo1.png" alt="logo" />
        <span class="nav-separator"></span>
        IRB
      </span>
    </div>

    <!-- Main (desktop) nav -->
    <div class="main-nav only-desktop" *ngIf="data$ | async as data">
      <ng-container *ngIf="data.isReader || data.isAdmin || data.isWarden">
        <a mat-button routerLink="/home"> <mat-icon>list</mat-icon>Protocols</a>

        <button mat-button [matMenuTriggerFor]="reportsMenu" class="menu-button">
          <mat-icon>assessment</mat-icon>
          Reports <mat-icon class="submenu-indicator">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #reportsMenu="matMenu">
          <button mat-menu-item routerLink="/report">IRB Report</button>
          <button mat-menu-item routerLink="/report/principalinvestigator">PI Report</button>
          <button mat-menu-item routerLink="/report/researchpersonnel">Research Personnel Report</button>
        </mat-menu>
      </ng-container>




      <ng-container *ngIf="data.isAdmin || data.isWarden">
        <button mat-button [matMenuTriggerFor]="adminMenu" class="menu-button">
          <mat-icon>admin_panel_settings</mat-icon>
          Admin <mat-icon class="submenu-indicator">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #adminMenu="matMenu">
          <button mat-menu-item routerLink="/admin/users">System Users</button>
          <button mat-menu-item routerLink="/admin/options">Options</button>
          <button mat-menu-item routerLink="/admin/researchers">Users</button>
        </mat-menu>
      </ng-container>
    </div>

    <span style="flex: 1 1 auto"></span>

    <!-- Profile button (desktop) -->
    <ng-container *ngIf="data$ | async as data; else noAuth">
      <button mat-button class="only-desktop" [matMenuTriggerFor]="profileMenu">
        <mat-icon>person</mat-icon> {{ data.user?.given_name }} {{ data.user?.family_name }}
      </button>
      <mat-menu #profileMenu="matMenu">
        <ng-container *ngIf="data.isWarden">

          <button mat-menu-item (click)="copyToClipboard()">
            <mat-icon>vpn_key</mat-icon>
            Get Token</button>
        </ng-container>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>Logout</button>
      </mat-menu>
    </ng-container>

    <ng-template #noAuth>
      <button mat-button class="only-desktop" (click)="login()">Login</button>
    </ng-template>

    <!-- 📱 Mobile all-in-one menu -->
    <mat-menu #mobileMenu="matMenu">
      <ng-container *ngIf="data$ | async as data; else mobileGuest">
        <button mat-menu-item routerLink="/home">
          <mat-icon>list</mat-icon>
          <span>Protocols</span>
        </button>

        <!-- Reports (nested) -->
        <button mat-menu-item [matMenuTriggerFor]="mobileReports" [matMenuTriggerDisabled]="true"
          #mobileReportsTrigger="matMenuTrigger" (click)="toggleMobileSubmenu(mobileReportsTrigger)">
          <mat-icon>assessment</mat-icon>
          <span>Reports</span>
        </button>
        <mat-menu #mobileReports="matMenu" [hasBackdrop]="true" [restoreFocus]="false">
          <button mat-menu-item routerLink="/report" (click)="closeAllMenus()">IRB Report</button>
          <button mat-menu-item routerLink="/report/principalinvestigator" (click)="closeAllMenus()">PI Report</button>
          <button mat-menu-item routerLink="/report/researchpersonnel" (click)="closeAllMenus()">Research Personnel
            Report</button>
        </mat-menu>

        <!-- Admin (nested) -->
        <ng-container *ngIf="data.isWarden || data.isAdmin">
          <button mat-menu-item [matMenuTriggerFor]="mobileAdmin" [matMenuTriggerDisabled]="true"
            #mobileAdminTrigger="matMenuTrigger" (click)="toggleMobileSubmenu(mobileAdminTrigger)">
            <mat-icon>admin_panel_settings</mat-icon>
            <span>Admin</span>
          </button>
          <mat-menu #mobileAdmin="matMenu" [hasBackdrop]="true" [restoreFocus]="false">
            <button mat-menu-item routerLink="/admin/users" (click)="closeAllMenus()">System Users</button>
            <button mat-menu-item routerLink="/admin/options" (click)="closeAllMenus()">Options</button>
            <button mat-menu-item routerLink="/admin/researchers" (click)="closeAllMenus()">Users</button>
          </mat-menu>
        </ng-container>

        <mat-divider></mat-divider>

        <!-- Profile actions on mobile -->
        <ng-container *ngIf="data.isWarden">
          <button mat-menu-item (click)="copyToClipboard()">
            <mat-icon>vpn_key</mat-icon>
            <span>Get Token</span>
          </button>
        </ng-container>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </ng-container>

      <ng-template #mobileGuest>
        <button mat-menu-item (click)="login()">
          <mat-icon>login</mat-icon>
          <span>Login</span>
        </button>
      </ng-template>
    </mat-menu>

  </mat-toolbar-row>
</mat-toolbar>
